import { ModuleModel } from '../../module.model.interface';
import { FormDescriptor } from '../../form/model/form';
import { OrganizationModel } from '../../organization/model/organization.model';
import { CaseCategoryDescriptor } from '../../case.category/model/case.category';
import { ProfileModel } from '../../profile/model/profile.model';
import { CaseHistoryDescriptor } from '../../case.history/model/case.history';

export enum CaseState {
  Created,
  SentToOffice,
  SentToClient,
  Closed
}

export class CaseStateDetail {
  public id: string;
  public name: string;

  constructor(options?: {
    id: string,
    name: string,
  }) {

    if (options) {
      this.id = options.id;
      this.name = options.name;
    }
  }
}

export const CaseStateMap = {
  Created: new CaseStateDetail({ id: 'Created', name: 'Létrehozva' }),
  SentToOffice: new CaseStateDetail({ id: 'SentToOffice', name: 'Továbbítva - hivatalnak' }),
  SentToClient: new CaseStateDetail({ id: 'SentToClient', name: 'Továbbítva - adatszolgáltatónak' }),
  Closed: new CaseStateDetail({ id: 'Closed', name: 'Lezárva' })
};

export const CaseStateList: CaseStateDetail[] = [
  CaseStateMap.Created,
  CaseStateMap.SentToOffice,
  CaseStateMap.SentToClient,
  CaseStateMap.Closed,
];

export class CaseDescriptor implements ModuleModel {
  public discriminator = 'CaseDescriptor';

  public id: string;
  public identifier: string;
  public categoryId: string;
  public organizationId: string;
  public formId: string;
  public periodStart: Date;
  public subject: string;
  public anonymousCreatorEmailAddress: string;
  public caseState: CaseState;
  public createdBy: string;
  public createdOn: Date;
  public assignedTo: string;
  public responsible: string;

  public historyEntries: CaseHistoryDescriptor[];

  public href: string;
  public modified: Date;
  public deleted: Date;

  public categoryDetail?: CaseCategoryDescriptor;
  public categoryName: string;
  public formDetail?: FormDescriptor;
  public formTitle?: string;
  public organizationDetail?: OrganizationModel;
  public organizationTitle?: string;
  public assignedDetail?: ProfileModel;
  public assignedFullName?: string;
  public responsibleDetail?: ProfileModel;
  public responsibleFullName?: string;
  public createdByDetail?: ProfileModel;
  public createdByFullName?: string;

  constructor(options?: {
    id: string;

    identifier: string;
    categoryId: string;
    organizationId: string;
    formId: string;
    periodStart: Date;
    subject: string;
    anonymousCreatorEmailAddress: string;
    caseState: CaseState;
    createdBy: string;
    createdOn: Date;
    assignedTo: string;
    responsible: string;

    href: string;
    modified: Date;
    deleted: Date;
  }) {

    if (options) {
      this.id = options.id;

      this.identifier = options.identifier;
      this.categoryId = options.categoryId;
      this.organizationId = options.organizationId;
      this.formId = options.formId;
      this.periodStart = options.periodStart;
      this.subject = options.subject;
      this.anonymousCreatorEmailAddress = options.anonymousCreatorEmailAddress;
      this.caseState = options.caseState;
      this.createdBy = options.createdBy;
      this.createdOn = options.createdOn;
      this.assignedTo = options.assignedTo;
      this.responsible = options.responsible;

      this.href = options.href;
      this.modified = options.modified;
      this.deleted = options.deleted;
    }

  }
}

export enum CaseMachineAttributeName {
  Message,
  Justification,
  InternalOrExternalJustification
}

export class CaseMachineAttribute {
  public name: CaseMachineAttributeName;
  public value: string;

  constructor(options?: {
    name: CaseMachineAttributeName;
    value: string;
  }) {

    if (options) {
      this.name = options.name;
      this.value = options.value;
    }
  }
}

export enum CaseMachineCommand {
  SendToOffice,
  SendToClient,
  Close,
  Reopen
}

export const CaseMachineCommandMessage = {
  SendToOffice: { done: 'A kérés küldése sikeresen megtörtént.', fail: 'A kérés küldése nem sikerült.' },
  SendToClient: { done: 'A válasz küldése sikeresen megtörtént.', fail: 'A válasz küldése nem sikerült.' },
  Close: { done: 'Az ügyfélkapcsolat lezárása sikeresen megtörtént.', fail: 'Az ügyfélkapcsolat lezárása nem sikerült.' },
  Reopen: { done: 'Az ügyfélkapcsolat újranyitása sikeresen megtörtént.', fail: 'Az ügyfélkapcsolat újranyitása nem sikerült.' }
};

export class CaseMachineStateDescriptor implements ModuleModel {
  public discriminator = 'CaseMachineStateDescriptor';

  public command?: CaseMachineCommand;
  public attributes?: CaseMachineAttribute[];

  constructor(options?: {
    command?: CaseMachineCommand;
    attributes?: CaseMachineAttribute[];
  }) {

    if (options) {
      this.command = options.command;
      this.attributes = options.attributes;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/case/model/case.ts